import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const getHistoryOrderObjectByOrderId = (orderGUID: string) =>
    createSelector(historyOrdersState, (historyOrders) => historyOrders?.orders?.find((order) => order.orderGUID === orderGUID) || null);
